module.exports = "/_next/static/images/Hero-b933f26ef7ee364f4caa2c67b2003c63.webp";